module.exports = __webpack_public_path__ + "static/img/app.b3cb6604.png";